import { SvgIcon } from '@material-ui/core'

const FacebookRedondo = () => (
    <SvgIcon width="30" height="30" viewBox="0 0 30 30" fill="none" class="so ss">
        <path fill-rule="evenodd" clipRule="evenodd" d="M15 27a12 12 0 1 0 0-24 12 12 0 0 0 0 24zm-1.23-6.03V15.6H12v-2.15h1.77v-1.6C13.77 10 14.85 9 16.42 9c.75 0 1.4.06 1.58.08v1.93h-1.09c-.85 0-1.02.43-1.02 1.05v1.38h2.04l-.27 2.15H15.9V21l-2.13-.03z" fill="#292929"></path>
    </SvgIcon>
)

export default FacebookRedondo